import VyhlasovanieVZbierke from './VyhlasovanieVZbierke';

export default VyhlasovanieVZbierke;
